import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useUsers() {
  const query = useQuery({
    queryKey: ["platform-users"],
    staleTime: 30_000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_all_platform_users");
      if (error) throw error;
      return (data ?? []).filter(
        (u: { admin_role?: string | null }) => u.admin_role !== "superuser"
      );
    },
  });

  return {
    users: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error ? (query.error as Error).message : null,
    refetch: query.refetch,
  };
}

export type PlatformUser = ReturnType<typeof useUsers>["users"][number];
